import React from 'react';
import PropTypes from 'prop-types';


const TextDate = ({ value, className }) => {
    let datestring = "";  
    if ((value) && (value !== null) && (typeof value.getMonth === 'function')) {
      let day = value.getDate().toString();
      if (value.getDate() < 10) {
        day = "0" + value.getDate().toString();
      }
      let month = (value.getMonth() + 1).toString();
      if (value.getMonth() + 1 < 10) {
        month = "0" + (value.getMonth() + 1).toString();
      }
      datestring = day + "." + month + "." + value.getFullYear();          
      // if (date < new Date(1, 0, 1, 0, 0, 0, 0)){        
      //   datestring = "";
      // }
      
    }    
    return (
      <span className={className}>{datestring}</span>
    );
  };
  
  TextDate.propTypes = {
    value: PropTypes.object,
    className: PropTypes.string
  };
  
  export default TextDate;